let backendConfig = {
  CONFIG_API_URL:
    "https://u1le2d3in2.execute-api.us-east-1.amazonaws.com/default/getGatewayDetails",
  CONFIG_API_KEY: "Q4DlRUhCRX65V0mERJERHawlmmtAqPN72KihWvJW",
  SECRET_KEY_TO_ENCRYPT: "sguetri36aoueqokksns",
  API_URL: "",
  API_END_POINTS: {},
  API_KEY: "",
  PUBSUB_ENV: "",
  CURRENT_ENV: "",
  featureFlag: {}
};

export { backendConfig };
